import type { Button } from '@moniebook-web/components/atoms/button';
import { create } from 'zustand';
import { type ComponentProps } from 'react';

type ButtonProps = ComponentProps<typeof Button>;

export interface AlertProps {
    title: string;
    message?: string;
    onClose: VoidFunction;
    onConfirm: VoidFunction;
    confirmText?: string;
    cancelText?: string;
    cancelTheme?: ButtonProps['theme'];
    confirmTheme?: ButtonProps['theme'];
    disableConfirm?: boolean;
    showCancelButton?: boolean;
    secondaryActionText?: string;
    secondaryActionTheme?: ButtonProps['theme'];
    secondaryActionClassName?: string;
    onSecondaryAction?: VoidFunction;
}

interface AlertStore {
    props?: AlertProps;
    showModal: (props: AlertProps) => void;
    hideModal: VoidFunction;
}

export const useAlert = create<AlertStore>((set) => ({
    props: undefined,
    hideModal: () => {
        set({ props: undefined });
    },
    showModal: (props) => {
        set({ props });
    },
}));
